import React from "react";
import Modal from "react-modal";
import classNames from "classnames";
import { HeaderDiscountItem } from "../common";

interface DiscountMenuModalProperties {
    readonly parentSelector: HTMLElement;
    readonly items: HeaderDiscountItem[];
    readonly onClose: () => void;
}

export default function DiscountMenuModal({ parentSelector, items, onClose }: DiscountMenuModalProperties): React.JSX.Element {
    const [isOpen, setIsOpen] = React.useState<boolean>(true);

    const closeModal = (): void => {
        setIsOpen(false);
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            id="#headerContainerDiscounts"
            className="header-categories-menu-modal"
            portalClassName="header-categories-menu-modal"
            parentSelector={() => parentSelector}
            overlayElement={(_properties, contentElement) => contentElement}
            /* eslint-disable-next-line react/jsx-no-useless-fragment */
            contentElement={(_properties, children) => <>{children}</>}
        >
            <div className="header-categories-menu-modal-left">
                <button type="button" className="close" onClick={closeModal}>
                    <i className="fa-solid fa-times"></i>
                </button>

                {items.map((item) => <a key={item.id} href={item.url} id={`discount-menu-item-${item.id}`}>
                    <div className="col-lg-3 col-sm-4 col-xs-12">
                        <div className={classNames("header-categories-menu-modal-item-wrap", item.id)}>
                            <i className={`fa-solid fa-${item.icon}`}></i>
                            {item.images.map((image) => <img key={image.url} src={image.url} alt="" className={image.css} />)}
                            <span>{item.title}</span>
                        </div>
                    </div>
                </a>)}
            </div>
            <div className="header-categories-menu-modal-right">
            </div>
        </Modal>
    );
}
